import { render, staticRenderFns } from "./send-gift-buttons.vue?vue&type=template&id=2145dee6&scoped=true&"
import script from "./send-gift-buttons.vue?vue&type=script&lang=js&"
export * from "./send-gift-buttons.vue?vue&type=script&lang=js&"
import style0 from "./send-gift-buttons.vue?vue&type=style&index=0&id=2145dee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145dee6",
  null
  
)

export default component.exports